<template>
  <div>
    <v-layout column justify-center align-center my-4>
      <o-base-center-text>
        <v-flex class="lg8">
          <span v-html="textoBase"/>
        </v-flex>
      </o-base-center-text>
    </v-layout>
      <v-layout mb-3 justify-center>
        <v-icon color="primary" class="custom-icon icon-job" style="font-size:200px;"/>
      </v-layout>
      <o-base-center-text v-if="!incrustado">
        <v-flex>
           {{$t('reservas.documentacion.avisoValidacion')}}
        </v-flex>
      </o-base-center-text>
      <v-layout justify-center>
        <v-btn 
          large color="primary"
          @click="$emit('continuar')"
          :disabled="cargandoExterior"
          :loading="cargandoExterior"
        >
         {{$t('reservas.documentacion.aceptar')}}
        </v-btn>
      </v-layout>
  </div>
    
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    incrustado: {
      type: Boolean,
      default: false
    },
    cargandoExterior: {
      type: Boolean,
      default: false
    },
    tipo: {
      type: String,
      default: 'validacionDocumentacion'
    }
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters({
      usuario: 'login/usuario',
      promocion: 'promociones/getActual'
    }),
    textoBase () {
      switch (this.tipo) {
        case 'validacionDocumentacion':
          return this.getTexto('documentacion.validacion', this.promocion.codigo)
        case 'pbc':
          return this.getTexto('pbc.validacion', this.promocion.codigo)
        default:
          return ''
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/reservas/documentacion/DocumentacionTerminado.vue